import { defineStore } from 'pinia'
import { computed, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useFetch } from '@/modules/shared/composables/use-fetch'

///////////////////////////////////////////////////////////////////////////////
// Store
///////////////////////////////////////////////////////////////////////////////

export const useUnivesrityStore = defineStore('shared/universityStore', () => {
  const route = useRoute()
  const baseUrl = computed(() => `/${route.params.slug}/shared`)

  const us_universities = ref<string[]>([])

  const fetchUSUniversities = async () => {
    const { data, error } = await useFetch(`${baseUrl.value}/universities/us`).get().json<{ data: string[] }>()

    if (error.value) {
      console.error(error.value)
      return
    }

    us_universities.value = data.value.data
  }

  ///////////////////////////////////////////////////////////////////////////////
  // Options
  ///////////////////////////////////////////////////////////////////////////////

  const usUniversityOptions = computed(() =>
    us_universities.value.map((university) => {
      return {
        label: university[0],
        value: university[1],
      }
    }),
  )

  return {
    us_universities,

    fetchUSUniversities,

    usUniversityOptions,
  }
})
